import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { MainButtonComponent } from './main-button/main-button.component';
import { TopComponent } from './top/top.component';
import { ButtonComponent } from './button/button.component';
import { LinkButtonComponent } from './link-button/link-button.component';
import { RouterModule } from '@angular/router';
import { PyramidComponent } from './pyramid/pyramid.component';
import { PyramidCompactComponent } from './pyramid-compact/pyramid-compact.component';
import { PyramidSubpageLayoutComponent } from './pyramid-subpage-layout/pyramid-subpage-layout.component';
import { PyramidRecommendationComponent } from './pyramid-recommendation/pyramid-recommendation.component';
import { FooterComponent } from './footer/footer.component';

@NgModule({
  declarations: [
    HeaderComponent,
    MainButtonComponent,
    TopComponent,
    ButtonComponent,
    LinkButtonComponent,
    PyramidComponent,
    PyramidCompactComponent,
    PyramidSubpageLayoutComponent,
    PyramidRecommendationComponent,
    FooterComponent,
  ],
  imports: [CommonModule, RouterModule],
  exports: [
    HeaderComponent,
    MainButtonComponent,
    TopComponent,
    ButtonComponent,
    LinkButtonComponent,
    PyramidComponent,
    PyramidCompactComponent,
    PyramidRecommendationComponent,
    PyramidSubpageLayoutComponent,
    FooterComponent,
  ],
})
export class SharedModule {}
